import React from "react";
import { Descriptions, Typography, Space, Tag } from "antd";
const { Title } = Typography;

const SpoOrder = ({ resource }) => {
  const { payload } = resource;
  return (
    <>
      <Title level={4}>Order Information</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="business name">{payload.business_name}</Descriptions.Item>
        <Descriptions.Item label="Website">{payload.business_website}</Descriptions.Item>
        <Descriptions.Item label="Keywords">
          <Space direction="vertical">
            {payload.keywords?.map((t) => (
              <Tag color="gray" key={t.label}>{t.label.toUpperCase()}</Tag>
            ))}
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="Max clicks per month">{payload.max_clicks}</Descriptions.Item>
        <Descriptions.Item label="Locations">{payload.locations}</Descriptions.Item>
        <Descriptions.Item label="Services">{payload.services}</Descriptions.Item>
        <Descriptions.Item label="Autocomplete term">{payload.autocomplete_term}</Descriptions.Item>
        <Descriptions.Item label="Agreement">
          {resource.intake_form &&
            <a target="_blank" href={resource.intake_form.url}>
              {resource.intake_form.name}
            </a>
          }
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default SpoOrder;
